export default __webpack_public_path__ + "static/media/w.f0e180ac.jpg";